import {Component, OnInit} from '@angular/core';
import {FiltersSearch} from './filters-search';
import {SearchType, ListingCategory} from '../../../classes/enums';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-filters-search-mobile',
  templateUrl: './filters-search.mobile.component.html',
  styleUrls: ['../filters.component.scss', '../filters.mobile.component.scss', 'filters-search.mobile.component.scss']
})
export class FiltersSearchMobileComponent extends FiltersSearch implements OnInit {

  ngOnInit() {
    super.ngOnInit();
    this.formDebounceTimeInMs = 500;

    this.addSub(this.onFiltersChange.subscribe((filters) => {
      this.communicationService.filters.search.next(filters);
    }));

    this.addSub(this.communicationService.filters.totalHits.subscribe((totalHits) => {
      document.querySelector('app-drawer .drawer-sub-title-right').innerHTML =  this.translateService.instant('filters.n-results', {n: totalHits});
    }));

    this.listenToFormChanges();
  }

  /**
   */
  protected fetchFilters() {
    (this.searchType === SearchType.AGENT ?
      this.preferencesService.agentSearchFiltersChanged :
      this.preferencesService.officeSearchFiltersChanged
    ).pipe(take(1)).toPromise().then((filters) => {
      if (this.currentShownListingType === ListingCategory.COMMERCIAL) {
        this._updateRealEstateFilterForPropertyType(filters, 'Commercial');
      }
      this.updateFilters(filters);
    });
  }
}
